import React from 'react';
import { useTranslation } from 'react-i18next';

const StructureSectionComponent = () => {
  const { t } = useTranslation();

  const sections = [
    {
      title: t('structure_section.persona.title'),
      description: t('structure_section.persona.description'),
      icon: '/images/persona.png',
    },
    {
      title: t('structure_section.task.title'),
      description: t('structure_section.task.description'),
      icon: '/images/aufgabe.png',
    },
    {
      title: t('structure_section.context.title'),
      description: t('structure_section.context.description'),
      icon: '/images/kontext.png',
    },
    {
      title: t('structure_section.examples.title'),
      description: t('structure_section.examples.description'),
      icon: '/images/beispiele.png',
    },
    {
      title: t('structure_section.format.title'),
      description: t('structure_section.format.description'),
      icon: '/images/format.png',
    },
    {
      title: t('structure_section.tone_style.title'),
      description: t('structure_section.tone_style.description'),
      icon: '/images/ton&stil.png',
    },
  ];

  return (
    <div className="px-12">
      <div className="title text-4xl pb-3">{t('structure_section.title')}</div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {sections.map(({ title, description, icon }) => (
          <div key={title} className="flex flex-col items-center space-y-6">
            <img
              src={icon}
              alt={`${title} icon`}
              className="w-full max-w-full aspect-square object-contain"
            />
            <h3 className="text-2xl text-center font-semibold">{title}</h3>
            <div className="bg-gray-100 p-3 md:p-4 rounded text-center flex-grow w-full">
              <p className="text-xs sm:text-sm text-gray-700">{description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StructureSectionComponent;
